import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { delay, map, mergeMap, filter } from 'rxjs/operators';
import { CancelUpdatedTourAnimation, OpenNotification, UiActionTypes } from '../actions';
import { LoadTourSingleSuccess, TourActionTypes } from '../../overview/store/actions';
import { getNotifications } from '../selectors';
import { Store } from '@ngrx/store';
import { AppState } from '../registration';

@Injectable()
export class UiEffects {
    constructor(
        private actions$: Actions,
        private store: Store<AppState>
    ) {
    }

    
    cancelUpdatedTourAnimation$ = createEffect(() => this.actions$.pipe(
        ofType(TourActionTypes.LOAD_TOUR_SINGLE_SUCCESS),
        delay(4000),
        map((action: LoadTourSingleSuccess) => new CancelUpdatedTourAnimation(action.payload.id))
    ));

    
    checkNotificationOnExit$ = createEffect(() => this.actions$.pipe(
        ofType(UiActionTypes.CHECK_NOTIFICATION_ON_EXIT),
        mergeMap(() => this.store.select(getNotifications)),
        filter(notifications => !!notifications.length),
        map(notifications => {
            const updatesNotification = notifications.find(item => item.type === 'app-new-version');
            const notificationId = updatesNotification ? updatesNotification.id : notifications[notifications.length - 1].id;

            return new OpenNotification(notificationId);
        })
    ));
}

